export default __webpack_public_path__ + "static/media/Crossing-Gray-24x24.e5c6c2f4.svg";